import React, { useState } from 'react';
import { createBetRecord } from '../../../api/betsApi';
import normalizeString from '../../../utils/normalize';

export const LotteriesForm = ({ formInfo, valuesAllowed }) => {
    const [serial, setSerial] = useState('');
    const [result, setResult] = useState('');
    const [series, setSeries] = useState('');
    const [resultError, setResultError] = useState('');
    const [loading, setLoading] = useState(false);
    const [blockOnsend, setblockOnsend] = useState(false);

    const actualDate = new Date().toISOString().split('T')[0];
    const handleSubmit = async (e) =>{
        e.preventDefault();
        const resultNumber = Number(result);
        if(resultNumber < valuesAllowed.result[0] || resultNumber > valuesAllowed.result[1]){
            setResultError(`El resultado debe tener un valor entre ${String(valuesAllowed.result[0]).padStart(2, '0')} y ${String(valuesAllowed.result[1]).padStart(2, '0')}`);
        }else{
            setResultError('');
            try {
                const betName = normalizeString(formInfo.name);
                const betInfo = {
                  betName: betName,
                  serialNumber: Number(serial),
                  result: result.split(""),
                  series: series,
                  date: e.target.elements[`Fecha del sorteo ${formInfo?.name}`]?.value
                }
                await createBetRecord(betName, betInfo);
                setblockOnsend(true);
                alert('Registro creado con éxito');
              } catch (error) {
                setblockOnsend(false);
                alert('Error al crear el registro');
              } finally {
                setLoading(false);
            }
        }
    };

    const handleSerialChange = (e) =>{
        const value = e.target.value.replace(/\D/g, '').slice(0, 4);
        setSerial(value);
    };
    const handleResultChange = (e) =>{
        const value = e.target.value.replace(/\D/g, '').slice(0, 4);
        setResult(value);
    };
    const handleSeriesChange = (e) =>{
        const value = e.target.value.replace(/\D/g, '').slice(0, 3);
        setSeries(value);
    };

    const handleResultBlur = (e) => {
        const value = e.target.value;
        const resultNumber = Number(value);
    
        if(resultNumber < valuesAllowed.result[0] || resultNumber > valuesAllowed.result[1]){
          setResultError(`El número debe tener un valor entre ${String(valuesAllowed.result[0]).padStart(4, '0')} y ${String(valuesAllowed.result[1]).padStart(4, '0')}`);
        }else{
          setResultError('');
        }
    
        setResult(value.padStart(4, "0"));
    };

    const handleSeriesBlur = (e) => {
        const value = e.target.value;
    
        setSeries(value.padStart(3, "0"));
    };
    return (
        <form noValidate onSubmit={handleSubmit} className="mb-4">
            <fieldset>
                <div className="mb-4 row">
                    <div className="col-md-12 col-12">
                        <div className="card">
                            <div className="card-header">
                                <a href={`/admin/${normalizeString(formInfo?.name)}`}><strong>{formInfo?.name}</strong></a>
                            </div>
                            <div className="card-body">
                                {formInfo?.serial ? <div className="form-group mb-3">
                                    <label className="form-label">Número del sorteo</label>
                                    <input
                                        type="text"
                                        value={serial}
                                        maxLength="4"
                                        inputMode="numeric"
                                        name={`Numero del sorteo ${formInfo?.name}`}
                                        placeholder="0000"
                                        className="form-control"
                                        onChange={handleSerialChange}
                                        style={{ fontSize: '13px' }}
                                        required
                                        disabled={blockOnsend}
                                    />
                                </div> : ''}
                                <div className="form-group mb-3">
                                    <label className="form-label">Resultados del sorteo</label>
                                    <div className="input-group" style={{ width: 'fit-content' }}>
                                        <input 
                                            type="text"
                                            value={result}
                                            maxLength="4"
                                            inputMode="numeric"
                                            name={`Resultado ${formInfo?.name}`} 
                                            className="form-control text-center"
                                            onChange={handleResultChange}
                                            onBlur={handleResultBlur}
                                            placeholder="0001" 
                                            aria-label='balota' 
                                            style={{ fontSize: '13px', width: '70px', height: 'auto' }}
                                            required
                                            disabled={blockOnsend}
                                        />
                                        <div className="invalid-feedback">{resultError}</div>
                                    </div>
                                </div>
                                <div className="form-group mb-3">
                                    <label className="form-label">Serie del sorteo</label>
                                    <div className="input-group" style={{ width: 'fit-content' }}>
                                        <input 
                                            type="number"
                                            value={series}
                                            maxLength="3"
                                            inputMode="numeric"
                                            name={`Serie ${formInfo?.name}`} 
                                            className="form-control text-center" 
                                            onChange={handleSeriesChange}
                                            onBlur={handleSeriesBlur}
                                            placeholder="001" aria-label='balota' 
                                            style={{ fontSize: '13px', width: '70px', height: 'auto' }}
                                            required
                                            disabled={blockOnsend}
                                        />
                                    </div>
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-label">Fecha del sorteo</label>
                                    <input
                                        type="date"
                                        name={`Fecha del sorteo ${formInfo?.name}`}
                                        className="form-control"
                                        defaultValue={actualDate}
                                        style={{ fontSize: '13px' }}
                                        required
                                        disabled={blockOnsend}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>

            <button type="submit" className="btn btn-primary" disabled={loading || blockOnsend}>
                {loading ? 'Añadiendo...' : blockOnsend ? 'Enviado correctamente' : 'Enviar'}
            </button>
        </form>
    );
};